import { useQueryClient } from '@tanstack/vue-query'
import { getById } from '@/api/locations'
import moment from 'moment'

export const noLocationOption = {
  id: null,
  title: 'Let the dispatcher decide',
  subTitle: 'Show jobs with no specified pickup location',
  selectable: true,
}

export function useLocationResolver() {
  const client = useQueryClient()

  const locationValueResolver = async (id) => {
    if (id === null) {
      return noLocationOption
    }

    try {
      const location = await client.fetchQuery({
        queryKey: ['locations', id],
        queryFn: ({ signal }) => getById(id, signal),
        staleTime: moment.duration(10, 'minutes').asMilliseconds(),
      })
      return { id: location.id, title: location.location }
    } catch (error) {
      return { id, title: `Error resolving ID: ${id}` }
    }
  }

  return {
    locationValueResolver,
  }
}
